/* ELF-FB20 lander, round 2 (13 Oct 2026): mode loop hero, tube grade slider with lightbox, slider 1 mode switch.
   Prices come from the buy column's own data (data-no-buy-data), never typed here. No em or en dashes. */
(function () {
  var ROOT = '#no-dfb31';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  /* ---------- prices from the page ---------- */
  function pageData() {
    var js = $('[data-no-buy-data]');
    if (!js) return null;
    try { return JSON.parse(js.textContent); } catch (e) { return null; }
  }
  function money(D, cents) {
    var p = String((D && D.moneyProbe) || '$1,234,567.89');
    var m = p.match(/1(.?)234(.?)567(.?)(89)?/);
    if (!m) return '$' + (cents / 100).toFixed(2);
    var th = m[1] || '', dec = m[3] || '.', hasDec = !!m[4];
    var pre = p.slice(0, m.index), suf = p.slice(m.index + m[0].length);
    var w = String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, th);
    return pre + w + (hasDec ? dec + ('0' + (cents % 100)).slice(-2) : '') + suf;
  }
  function tiers() {
    var D = pageData(); var out = [];
    var grades = (D && D.grades) || [{ value: '1400-1550' }, { value: '1600-1800' }, { value: '1800-1950' }, { value: '2000-2100' }];
    var base = null;
    grades.forEach(function (g) {
      var v = D && D.variants ? D.variants.filter(function (x) { return x.options && x.options.indexOf(g.value) !== -1; })[0] : null;
      if (v && base === null) base = v.price;
      out.push({ value: g.value, v: v, ok: !!(v && v.available) });
    });
    out.forEach(function (t, i) {
      t.price = t.v ? money(D, t.v.price) : '';
      t.delta = !t.ok ? 'SOLD OUT' : (i === 0 || !t.v || base === null ? t.price : '+' + money(D, t.v.price - base).replace(/[.,]00(?=\D*$)/, ''));
    });
    return out;
  }

  /* ---------- MODE LOOP HERO ---------- */
  function modes() {
    var band = $(ROOT + ' [data-r2-modes]'); if (!band) return;
    var v = $('video', band), pill = $('[data-r2-mode]', band);
    var legend = $$(ROOT + ' [data-r2-mode-key]');
    var T = JSON.parse(band.getAttribute('data-r2-modes'));   /* [[start s, label], ...] */
    var seg = parseFloat(band.getAttribute('data-r2-seg') || '2.4');
    var rate = parseFloat(band.getAttribute('data-r2-rate') || '1');   /* round 3: the loop plays faster */
    var icons = $$('[data-r2-icon]', band);
    function labelAt(t) {
      var k = 0;
      for (var i = 0; i < T.length; i++) if (t >= T[i][0] - 0.2) k = i;
      return k;
    }
    var last = -1;
    function show(k, frac) {
      if (k !== last) {
        last = k;
        if (pill) { pill.setAttribute('aria-label', T[k][1]); var sr = $('.r2-sr', pill); if (sr) sr.textContent = T[k][1]; }
        icons.forEach(function (e, i) { e.classList.toggle('is-on', i === k); });
        legend.forEach(function (e, i) { e.classList.toggle('is-on', i === k); e.setAttribute('aria-pressed', i === k ? 'true' : 'false'); });
      }
      var bar = legend[k] && $('.r2-key-bar', legend[k]);
      if (bar) bar.style.transform = 'scaleX(' + Math.max(0, Math.min(1, frac)).toFixed(3) + ')';
    }
    function tick() {
      var t = v.currentTime || 0, k = labelAt(t);
      var next = k + 1 < T.length ? T[k + 1][0] : (v.duration || T[k][0] + seg);
      show(k, (t - T[k][0]) / Math.max(0.1, next - T[k][0]));
    }
    legend.forEach(function (e, i) {
      e.addEventListener('click', function () { try { v.currentTime = T[i][0] + 0.05; } catch (x) {} show(i, 0); });
    });
    if (reduced()) {
      v.removeAttribute('autoplay'); try { v.pause(); } catch (e) {}
      show(1, 1);
      return;
    }
    v.muted = true; v.loop = true; v.playsInline = true;
    v.defaultPlaybackRate = rate; v.playbackRate = rate;
    v.addEventListener('play', function () { if (v.playbackRate !== rate) v.playbackRate = rate; });
    v.addEventListener('loadedmetadata', function () { v.playbackRate = rate; });
    v.addEventListener('timeupdate', tick);
    (function raf() { tick(); window.requestAnimationFrame(raf); })();
    function play() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) play(); else { try { v.pause(); } catch (x) {} } });
      }, { threshold: 0.15 }).observe(band);
    } else play();
    document.addEventListener('visibilitychange', function () { if (!document.hidden) play(); });
  }

  /* ---------- TUBE GRADE ---------- */
  function grade() {
    var box = $(ROOT + ' [data-r2-grade]'); if (!box) return;
    var T = tiers(); var n = T.length; var cur = 0; var views = [];
    var title = $('[data-r2-gtitle]', box), fom = $('[data-r2-gfom]', box), price = $('[data-r2-gprice]', box), avail = $('[data-r2-gavail]', box), pick = $('[data-r2-pick]', box);

    function bindSlider(el) {
      var track = $('.r2-track', el), knob = $('.r2-knob', el), fill = $('.r2-fill', el), range = $('.r2-range', el);
      var dots = $$('.r2-dot', el), stops = $$('.r2-stop', el), imgs = $$('img[data-r2-gimg]', el.closest('[data-r2-view]') || el);
      stops.forEach(function (s, i) {
        var t = T[i]; if (!t) return;
        var sp = $('span', s); if (sp) { sp.textContent = t.delta; sp.classList.toggle('is-out', !t.ok); }
        s.addEventListener('click', function () { set(i, true); });
      });
      function frac(i) { return n > 1 ? i / (n - 1) : 0; }
      dots.forEach(function (d, i) { d.style.left = (frac(i) * 100) + '%'; d.classList.toggle('is-out', !(T[i] && T[i].ok)); });
      stops.forEach(function (s, i) { if (i > 0 && i < n - 1) s.style.left = (frac(i) * 100) + '%'; else if (i === 0) s.style.left = '0'; else s.style.left = '100%'; });
      function draw(i) {
        knob.style.left = (frac(i) * 100) + '%'; fill.style.width = (frac(i) * 100) + '%';
        dots.forEach(function (d, k) { d.classList.toggle('is-done', k <= i && T[k] && T[k].ok); });
        stops.forEach(function (s, k) { s.classList.toggle('is-on', k === i); s.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
        imgs.forEach(function (im) { im.classList.toggle('is-on', +im.getAttribute('data-r2-gimg') === i); });
        range.value = String(i); range.setAttribute('aria-valuetext', T[i].value + ' figure of merit, ' + (T[i].ok ? T[i].price : 'sold out'));
      }
      var dragging = false;
      function idxAt(x) {
        var r = track.getBoundingClientRect(); var f = Math.min(1, Math.max(0, (x - r.left) / r.width));
        return Math.round(f * (n - 1));
      }
      function liveAt(x) {
        var r = track.getBoundingClientRect(); var f = Math.min(1, Math.max(0, (x - r.left) / r.width));
        knob.style.left = (f * 100) + '%'; fill.style.width = (f * 100) + '%';
        var i = Math.round(f * (n - 1)); if (i !== cur) set(i, false, true);
      }
      track.addEventListener('pointerdown', function (e) {
        dragging = true; track.classList.add('is-drag');
        try { track.setPointerCapture(e.pointerId); } catch (x) {}
        liveAt(e.clientX); e.preventDefault();
      });
      track.addEventListener('pointermove', function (e) { if (dragging) liveAt(e.clientX); });
      function end(e) { if (!dragging) return; dragging = false; track.classList.remove('is-drag'); set(idxAt(e.clientX), true); }
      track.addEventListener('pointerup', end); track.addEventListener('pointercancel', end);
      track.addEventListener('keydown', function (e) { key(e); });
      range.addEventListener('input', function () { set(+range.value, true); });
      function key(e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { set(Math.min(n - 1, cur + 1), true); e.preventDefault(); }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { set(Math.max(0, cur - 1), true); e.preventDefault(); }
        if (e.key === 'Home') { set(0, true); e.preventDefault(); }
        if (e.key === 'End') { set(n - 1, true); e.preventDefault(); }
      }
      track.tabIndex = 0; track.setAttribute('role', 'slider'); track.setAttribute('aria-label', 'Tube grade');
      track.setAttribute('aria-valuemin', '0'); track.setAttribute('aria-valuemax', String(n - 1));
      return { draw: function (i) { draw(i); track.setAttribute('aria-valuenow', String(i)); track.setAttribute('aria-valuetext', T[i].value + ' figure of merit'); } };
    }

    function set(i, snap, live) {
      cur = Math.max(0, Math.min(n - 1, i));
      views.forEach(function (v) { if (!live || snap) v.draw(cur); else v.draw(cur); });
      var t = T[cur];
      if (title) title.textContent = t.value + ' FOM';
      if (fom) fom.textContent = t.value;
      if (price) price.textContent = t.price || '';
      if (avail) avail.textContent = t.ok ? 'built to order' : 'sold out';
      if (pick) { pick.disabled = !t.ok; pick.textContent = t.ok ? 'Pick this tier' : 'Sold out'; }
    }

    views.push(bindSlider($('.r2-slider', box)));
    /* lightbox: same four pictures at full width, same slider under them */
    var dlg = $(ROOT + ' dialog[data-r2-dialog]'), open = $('[data-r2-expand]', box);
    if (dlg && open) {
      views.push(bindSlider($('.r2-slider', dlg)));
      var opener = null;
      open.addEventListener('click', function () {
        opener = document.activeElement;
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
        set(cur, true);
        var c = $('.r2-close', dlg); if (c) c.focus();
      });
      $('.r2-close', dlg).addEventListener('click', function () { dlg.close ? dlg.close() : dlg.removeAttribute('open'); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      dlg.addEventListener('close', function () { if (opener && opener.focus) opener.focus(); });
      dlg.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var f = $$('button, [tabindex="0"]', dlg).filter(function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        var a = f[0], z = f[f.length - 1];
        if (e.shiftKey && document.activeElement === a) { z.focus(); e.preventDefault(); }
        else if (!e.shiftKey && document.activeElement === z) { a.focus(); e.preventDefault(); }
      });
    }
    if (pick) pick.addEventListener('click', function () {
      var t = T[cur]; if (!t.ok) return;
      var b = $(ROOT + ' #bundles [data-np-fom="' + t.value + '"]');
      if (b) b.click();
      var target = $(ROOT + ' #bundles .r2-order-card') || $(ROOT + ' #bundles');
      if (target) target.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
    });
    set(0, true);
  }

  /* ---------- SLIDER 1 MODE SWITCH ---------- */
  function sw() {
    var s = $(ROOT + ' [data-r2-switch]'); if (!s) return;
    var cmp = $(ROOT + ' [data-comparison="1"]'); if (!cmp) return;
    var withImg = cmp.querySelector(':scope > img'); if (!withImg) return;
    var cap = $(ROOT + ' [data-r2-switch-cap]');
    var srcs = { highlight: withImg.getAttribute('src'), outline: s.getAttribute('data-outline-src') };
    var alts = { highlight: withImg.getAttribute('alt'), outline: 'Illustration: the same view with ELF-FB20 thermal fusion on (Outline mode)' };
    var caps = { highlight: 'Highlight mode, red', outline: 'Outline mode' };
    var pre = new Image(); pre.src = srcs.outline;
    $$('button', s).forEach(function (b) {
      b.addEventListener('click', function () {
        var m = b.getAttribute('data-mode');
        $$('button', s).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        withImg.setAttribute('src', srcs[m]); withImg.setAttribute('alt', alts[m]);
        if (cap) cap.textContent = caps[m];
      });
    });
  }


  /* ---------- ORDER CARD FOM SLIDER (round 4, 14 Oct 2026) ----------
     The tier buttons keep data-np-fom: a pick is a click on that button, so dfb31-lander.js keeps the
     state, the total and the cart payload. Sold out tiers are shown and never picked. */
  function orderFom() {
    var box = $(ROOT + ' [data-r4-fom]'); if (!box) return;
    var track = $('.r2-track', box), knob = $('.r2-knob', box), fill = $('.r2-fill', box);
    var dots = $$('.r2-dot', box), stops = $$('[data-np-fom]', box), n = stops.length, cur = 0;
    var T = tiers();
    function tier(i) { var v = stops[i].getAttribute('data-np-fom'); return T.filter(function (t) { return t.value === v; })[0]; }
    function ok(i) { var t = tier(i); return !stops[i].disabled && stops[i].getAttribute('aria-disabled') !== 'true' && (!t || t.ok); }
    function frac(i) { return n > 1 ? i / (n - 1) : 0; }
    stops.forEach(function (s, i) {
      var t = tier(i), sp = $('span', s);
      if (t && sp) { sp.textContent = t.ok ? (i === 0 ? t.price : t.delta) : 'SOLD OUT'; sp.classList.toggle('is-out', !t.ok); }
      if (i > 0 && i < n - 1) s.style.left = (frac(i) * 100) + '%'; else s.style.left = i === 0 ? '0' : '100%';
      if (t && !t.ok) { s.disabled = true; s.setAttribute('aria-disabled', 'true'); s.title = 'Sold out'; }
    });
    dots.forEach(function (d, i) { d.style.left = (frac(i) * 100) + '%'; d.classList.toggle('is-out', !ok(i)); });
    function draw(i, at) {
      var f = at == null ? frac(i) : at;
      knob.style.left = (f * 100) + '%'; fill.style.width = (f * 100) + '%';
      dots.forEach(function (d, k) { d.classList.toggle('is-done', k <= i && ok(k)); d.classList.toggle('is-out', !ok(k)); });
      stops.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      var t = tier(i);
      track.setAttribute('aria-valuenow', String(i));
      track.setAttribute('aria-valuetext', stops[i].getAttribute('data-np-fom') + ' figure of merit' + (t && t.price ? ', ' + t.price : ''));
    }
    function nearestOk(i) {
      if (ok(i)) return i;
      for (var d = 1; d < n; d++) { if (i - d >= 0 && ok(i - d)) return i - d; if (i + d < n && ok(i + d)) return i + d; }
      return cur;
    }
    function bump() { box.classList.remove('is-bump'); void box.offsetWidth; box.classList.add('is-bump'); }
    function pick(i) {
      var j = nearestOk(i); if (j !== i) bump();
      cur = j; draw(j);
      if (stops[j].getAttribute('aria-pressed') !== 'true') stops[j].click();
    }
    stops.forEach(function (s, i) { s.addEventListener('click', function () { if (ok(i)) { cur = i; draw(i); } }); });
    var dragging = false;
    function fAt(x) { var r = track.getBoundingClientRect(); return Math.min(1, Math.max(0, (x - r.left) / r.width)); }
    track.addEventListener('pointerdown', function (e) {
      dragging = true; track.classList.add('is-drag'); try { track.setPointerCapture(e.pointerId); } catch (x) {}
      draw(Math.round(fAt(e.clientX) * (n - 1)), fAt(e.clientX)); e.preventDefault();
    });
    track.addEventListener('pointermove', function (e) { if (dragging) draw(Math.round(fAt(e.clientX) * (n - 1)), fAt(e.clientX)); });
    function end(e) { if (!dragging) return; dragging = false; track.classList.remove('is-drag'); pick(Math.round(fAt(e.clientX) * (n - 1))); }
    track.addEventListener('pointerup', end); track.addEventListener('pointercancel', end);
    track.addEventListener('keydown', function (e) {
      var k = e.key, i = cur;
      if (k === 'ArrowRight' || k === 'ArrowUp') { for (i = cur + 1; i < n && !ok(i); i++); if (i >= n) { bump(); i = cur; } }
      else if (k === 'ArrowLeft' || k === 'ArrowDown') { for (i = cur - 1; i >= 0 && !ok(i); i--); if (i < 0) i = cur; }
      else if (k === 'Home') i = nearestOk(0); else if (k === 'End') { i = nearestOk(n - 1); }
      else return;
      e.preventDefault(); pick(i);
    });
    var start = 0; stops.forEach(function (s, i) { if (s.getAttribute('aria-pressed') === 'true' && ok(i)) start = i; });
    cur = start; draw(start);
  }
  function init() {
    if (!$(ROOT) || document.documentElement.getAttribute('data-r2-dfb')) return;
    document.documentElement.setAttribute('data-r2-dfb', '1');
    try { modes(); } catch (e) {}
    try { grade(); } catch (e) {}
    try { sw(); } catch (e) {}
    try { orderFom(); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
